(function () {
  function initWrap(wrap) {
    if (!wrap || wrap.__sfbInit) return;
    wrap.__sfbInit = true;

    var dataEl = document.getElementById('sfb-data-' + wrap.id.replace('sfb-', ''));
    if (!dataEl) return;

    var payload = {};
    try { payload = JSON.parse(dataEl.textContent.trim()); } catch (e) { return; }

    var skuList = (payload.skus || []).map(function (s) { return s.toUpperCase(); });
    var variantsList = payload.variants || [];
    var variantsById = {};
    variantsList.forEach(function (v) { variantsById[String(v.id)] = (v.sku || '').toUpperCase(); });

    var pill = wrap.querySelector('.sfb-pill');
    if (!pill) return;

    var root = wrap.closest('[id^="shopify-section"]') || document;
    var variantIdInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');

    function hide() {
      pill.classList.remove('sfb-show');
      wrap.classList.remove('sfb-visible');
    }

    function show() {
      pill.classList.add('sfb-show');
      wrap.classList.add('sfb-visible');
    }

    function renderByVariantId(vid) {
      var sku = variantsById[String(vid)];
      if (sku && skuList.indexOf(sku) !== -1) {
        show();
      } else {
        hide();
      }
    }

    function getVariantIdFromURL() {
      try { return new URL(location.href).searchParams.get('variant'); } catch (_) { return null; }
    }

    function recompute() {
      if (variantIdInput && variantIdInput.value) return renderByVariantId(variantIdInput.value);
      var urlVid = getVariantIdFromURL();
      if (urlVid) return renderByVariantId(urlVid);
    }

    recompute();

    root.addEventListener('change', function (e) {
      var n = (e.target && e.target.name) || '';
      if (n.indexOf('options') === 0 || n === 'id') {
        setTimeout(recompute, 0);
      }
    });

    if (variantIdInput) {
      variantIdInput.addEventListener('change', recompute);
      new MutationObserver(recompute).observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });
    }

    ['variant:change', 'variant:changed', 'product:variant-change', 'theme:variant:change', 'product:change', 'theme:product:change']
      .forEach(function (evt) {
        document.addEventListener(evt, function (e) {
          var vid = (e && e.detail && (e.detail.id || (e.detail.variant && e.detail.variant.id))) || null;
          if (vid) renderByVariantId(vid); else recompute();
        });
      });

    ['pushState', 'replaceState'].forEach(function (m) {
      if (!history[m]._sfbWrapped) {
        var orig = history[m];
        history[m] = function () {
          var ret = orig.apply(this, arguments);
          try {
            if (arguments && arguments[2] && String(arguments[2]).indexOf('variant=') > -1) {
              document.querySelectorAll('.sfb-wrap').forEach(function (w) {
                if (w.__sfbInit && typeof w.__sfbRecompute === 'function') w.__sfbRecompute();
              });
            }
          } catch (_) {}
          return ret;
        };
        history[m]._sfbWrapped = true;
      }
    });

    wrap.__sfbRecompute = recompute;
    window.addEventListener('popstate', recompute);
  }

  function boot() { document.querySelectorAll('.sfb-wrap').forEach(initWrap); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:block:select', boot);
})();
